<template>
  <main>
    <Home />
    <Footer />
  </main>
</template>

<script>
import Home from "@/components/Home";
import Footer from "@/components/Footer";
export default {
  components: {
    Home,
    Footer
  }
};
</script>

<style scoped>
main {
  position: relative;
  display: grid;
  grid-template-rows: 1fr auto;
  overflow: auto;
  overflow-x: hidden;
  min-height: 100vh;
}
</style>
